import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Popover from 'react-bootstrap/Popover';

export const PopoverStyled = styled(Popover)`
  .popover-header {
      color: #0065B6;
      font-weight: 800;
      background-color: white;
      border-top: 5px solid #0065B6;
      border-bottom: none;
      font-size: 1.4rem;
      padding: 15px 15px 20px 20px;
      margin-top: -10px;
      
      .fa-question-circle {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
      }
  }
  .popover-body {
   padding: 0 15px 20px 20px;
  }
  
  
`;
export const AffiliationTriggerContainer = styled.div`
    // a {
    //     text-decoration: none;
    //     color: #0065B6;
    //     border-bottom: #0065B6 0.125em solid;
    //     font-size: 1.25rem;
    //     margin-right: 5px;
    // }
    // a:hover {
    //   text-decoration: none;
    //   color: #174F3E
    // }
    // .fa-question-circle {
    //   color: #0065B6;
    //   width: 20px;
    //   height: 20px;
    //   vertical-align: middle;
    //   &:hover {
    //     cursor: pointer;
    //   }
    // }
`;

export const StyledEdeLevel = styled.div`
    font-size: 1.2rem;
`;

export const PopoverHeaderCloseIcon = styled(FontAwesomeIcon)`
  float: right;
  color: #6A2200;
  &:hover {
  cursor: pointer;
  }
`;

